/* eslint-disable import/prefer-default-export */
import type { State } from '@src/redux/configureStore'

export const getUser = (state: State) => state.auth.user
export const getTenant = (state: State) => state.auth.tenant
